import React from 'react';
import { useRoSContext } from '@components/Presentation/context/RoSContext';
import Switch from '@molecules/Switch';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import Tooltip from '@components/Presentation/atoms/Tooltip';

function ShowCommentsOverlay() {
  const { selectedSlide } = useRoSContext();
  return (
    <div className="flex">
      <div className="flex-1 text-sm">
        Show comments overlay &nbsp;
        <Tooltip content="Show audience responses as a callout in the lower right corner of the presentation.">
          <HelpRoundedIcon
            fontSize="small"
            color="disabled"
            className='dark:text-grey-400'
          />
        </Tooltip>
      </div>
      <Switch
        checked={!!selectedSlide.setting.CommentsOverlay}
        onChange={(e) =>
          selectedSlide.handler.updateSetting(
            'CommentsOverlay',
            e.target.checked
          )
        }
        onClick={() => {}}
      />
    </div>
  );
}

export default ShowCommentsOverlay;
